<template>
  <O3D class="">
    <!-- <AmbinetLight :intensity="2.0"></AmbinetLight>
    <DirectionalLight :intensity="1.0"></DirectionalLight>
    <HemisphereLight :intensity="1.0"></HemisphereLight> -->

    <!-- <WoozyDiamonds :cubeCam="cubeCam" @o3d="game.out.o3d.add($event)"></WoozyDiamonds> -->

    <slot></slot>

    <!-- <div ref="touchdiv" class="absolute top-0 left-0 w-full h-full z-0"></div> -->

    <!-- <div v-if="game && game.charReady && showToolsBox && game.moves" class="p-1 select-none lg:select-text absolute z-20 top-0 left-0 text-xs lg:text-sm text-white w-56 overflow-y-auto moves-box">
      <div class="p-1" v-if="mode === 'full'">
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'all'" :style="{ backgroundColor: moveListFilter === 'all' ? 'green' : '' }">All</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'church'" :style="{ backgroundColor: moveListFilter === 'church' ? 'green' : '' }">Church</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'ready'" :style="{ backgroundColor: moveListFilter === 'ready' ? 'green' : '' }">Ready</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'posture'" :style="{ backgroundColor: moveListFilter === 'posture' ? 'green' : '' }">Posture</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'dance'" :style="{ backgroundColor: moveListFilter === 'dance' ? 'green' : '' }">Dance</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'football'" :style="{ backgroundColor: moveListFilter === 'football' ? 'green' : '' }">Football</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'action'" :style="{ backgroundColor: moveListFilter === 'action' ? 'green' : '' }">Action</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'combat'" :style="{ backgroundColor: moveListFilter === 'combat' ? 'green' : '' }">Combat</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'gun'" :style="{ backgroundColor: moveListFilter === 'gun' ? 'green' : '' }">Gun</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'control'" :style="{ backgroundColor: moveListFilter === 'control' ? 'green' : '' }">Control</a>
      </div>
      <a :ref="`item-${moveItem._id}`" v-for="moveItem in game.moves.filter(actionFilter)" :key="moveItem._id + moveItem.displayName" @click="gui('play-move', { move: moveItem }); lastClickedMove = moveItem" class="block px-2 mx-1 my-1 border-gray-100 border" :style="{ backgroundColor: lastClickedMove === moveItem ? '#4299e1' : 'rgba(0,0,0,0.3)' }">{{ moveItem.displayName }}</a>
    </div> -->

    <div class="touch-action-manipulation select-none absolute z-30 bottom-0 left-0 pl-5 pb-5" v-if="game && game.charReady">
      <div class="touch-action-manipulation select-none">
        <!-- <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border text-20 text-white bg-white" @click="showToolsBox = !showToolsBox">
          <img class="touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/party.svg" alt="">
        </div> -->
        <!-- <div v-if="mode !== 'church'" class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @click="gui('key-x', true)">
          <img class="touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/gamepad.svg" alt="">
        </div> -->
      </div>
      <div class="touch-action-manipulation select-none">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 w-12 h-12 border-gray-100 border  text-20 text-black" :class="{ 'bg-blue-500': game.useGyro, 'bg-white': !game.useGyro }" @click="() => gui('toggle-gyro', {})">
          AR
        </div>
        <!-- <div v-show="game && !game.useGyro" class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @click="() => gui('toggle-camcorder', {})">
          <img v-show="game.viewCameraMode === 'freecam'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/touch.svg" alt="">
          <img v-show="game.viewCameraMode !== 'freecam'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/camcorder.svg" alt="" />
        </div> -->
      </div>
      <div class="touch-action-manipulation select-none" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-forward', true)" @mousedown="gui('go-forward', true)"  @touchend="gui('go-forward', false)" @mouseup="gui('go-forward', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/up.svg" alt="">
        </div>
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-backward', true)" @mousedown="gui('go-backward', true)" @touchend="gui('go-backward', false)" @mouseup="gui('go-backward', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/down.svg" alt="">
        </div>
      </div>
    </div>

    <div class="touch-action-manipulation select-none  absolute z-30 bottom-0 right-0 pr-5 pb-5" v-if="game && game.charReady">
      <div class="touch-action-manipulation select-none flex justify-end">
        <div v-if="!hideMenu" class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border text-20 text-white bg-white" @click="goToPage()">
          <!-- <img v-if="mode !== 'church'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/church.svg" alt=""> -->
          <img class=" touch-action-manipulation scale-100 transform select-none  pointer-events-none" src="./img/menu.svg" alt="">
        </div>
      </div>

      <!-- <div class="touch-action-manipulation select-none" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('key-r', true)" @mousedown="gui('key-r', true)"  @touchend="gui('key-r', false)" @mouseup="gui('key-r', false)">
          <img v-show="game && game.moodType === 'peaceful'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/love.svg" alt="">
          <img v-show="game && game.moodType === 'fighting'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/fight1.svg" alt="">
        </div>
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('key-t', true)" @mousedown="gui('key-t', true)"  @touchend="gui('key-t', false)" @mouseup="gui('key-t', false)">
          <img v-show="game && game.moodType === 'peaceful'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/dance.svg" alt="">
          <img v-show="game && game.moodType === 'fighting'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/fight2.svg" alt="">
        </div>
      </div> -->

      <div class="touch-action-manipulation select-none" v-show="game && !game.useGyro" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('turn-left', true)" @mousedown="gui('turn-left', true)"  @touchend="gui('turn-left', false)" @mouseup="gui('turn-left', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/turn-left.svg" alt="">
        </div>
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('turn-right', true)" @mousedown="gui('turn-right', true)" @touchend="gui('turn-right', false)" @mouseup="gui('turn-right', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/turn-right.svg" alt="">
        </div>
      </div>

      <div class="touch-action-manipulation select-none" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-left', true)" @mousedown="gui('go-left', true)"  @touchend="gui('go-left', false)" @mouseup="gui('go-left', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/left.svg" alt="">
        </div>

        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-right', true)" @mousedown="gui('go-right', true)" @touchend="gui('go-right', false)" @mouseup="gui('go-right', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/right.svg" alt="">
        </div>
      </div>
    </div>

    <!-- <div v-if="showLoading" class="absolute top-0 left-0 h-full w-full flex justify-center items-center" :class="{ 'bg-transp-black': !game.charReady }">
      <div class="px-6 py-3 rounded-full bg-white"> {{loadingPercentage.toFixed(2)}}% Loading...</div>
    </div> -->
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { LoadingManager } from '../../Reusable/LoadingManager'
import { CamControl } from './CamControl.js'
import { EventDispatcher } from 'three'

export default {
  props: {
    canTune: {
      default: true,
    },
    mode: {
      default: 'full'
    },
    hideMenu: {
      default: false
    }
  },
  mixins: [O3DG2],
  data () {
    return {
      useBloom: false,
      // toolbox
      showToolsBox: this.mode === 'full' && window.innerWidth > 500,
      moveListFilter: ' ',
      lastClickedMove: false,

      loadingPercentage: 0,
      showLoading: false,
      game: false
    }
  },
  watch: {
    moveListFilter () {
      if (this.game) {
        if (this.moveListFilter === 'dance') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'posture') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'combat') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'action') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'gun') {
          this.game.viewCameraMode = 'freecam'
        } else {
          this.game.viewCameraMode = 'firstperson'
        }
      }
    }
  },
  methods: {
    goToPage () {
      window.location.assign('/menu')
    },
    actionFilter (item) {
      if (this.moveListFilter === 'all') {
        return true
      } else if (this.moveListFilter) {
        if (this.moveListFilter === item.type) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },

    gui (event, data) {
      this.game.dispatchEvent({ type: event, data: data })
    },

    setup () {
      this.moveListFilter = 'all'
      if (this.mode === 'church') {
        this.moveListFilter = 'church'
        // this.showToolsBox = false
      }

      let bus = new EventDispatcher()
      let gamechar = new CamControl({
        canTune: this.canTune,
        mode: this.mode,
        bus,
        renderer: this.ctx.renderer,
        touchdiv: this.ctx.touchdiv,
        loop: this.onLoop,
        clean: this.onClean,
        camera: this.ctx.camera,
        scene: this.ctx.scene,
        cubeCam: this.ctx.cubeCam
      })
      gamechar.out.done.then(() => {
        if (this.mode === 'full') {
          this.gui('key-x', true)
        }
        this.$emit('ready', true)
      })

      this.game = gamechar
      this.o3d.add(gamechar.out.o3d)
      this.$emit('char-o3d', gamechar.out.o3d)
      this.o3d.scale.x = 10
      this.o3d.scale.y = 10
      this.o3d.scale.z = 10
      this.o3d.rotation.y = Math.PI

      LoadingManager.hooks.push((v) => {
        if (v > 0 || !this.game.charReady) {
          this.showLoading = true
        }
        if (v === 1 && this.game.charReady) {
          this.showLoading = false
        }
        this.loadingPercentage = v * 100
        if (this.loadingPercentage < 0) {
          this.loadingPercentage = 0
        }
      })
    },

  },
  mounted () {
    this.setup()
    // this.setupBloom()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="postcss">
.moves-box{
  height: 170px;
}
@screen lg {
  .moves-box{
    height: calc(100% - 250px);
  }
}
.touch-action-manipulation{
  touch-action: manipulation;
}
.bg-transp-black{
  background-color: rgba(0,0,0,0.3);
}
.bg-transp-white{
  background-color: rgba(255,255,255,0.3);
}
.touch-action-manipulation {
  touch-action: manipulation;
}
</style>
